import { Card } from '../../../../../../components/card/card';
import { Container } from '../../../../../../components/container/container';
import { Select } from '../../../../../../components/select/select';
import { MultiSelect } from '../../../../../../features/multi-select/multi-select';
import s from './qr-links.module.css';
import { useQrLinks } from './use-qr-links';

export const QrLinks = () => {
  const { qr, handleUpdateQr, tags, trees, menuOptions, selectedTags, selectedTree, t } =
    useQrLinks();

  return (
    <Card className={s.feature} title={`3. ${t('Связи')}`}>
      {qr?.services?.includes('feedback') && (
        <Container label={t('Выберите дерево')} required>
          <Select
            options={trees}
            onSelect={(e) => handleUpdateQr({ tree_id: e.id })}
            value={selectedTree}
            name="tree"
            data-testid="qr-tree"
          />
        </Container>
      )}
      <Container label={t('Выберите ответственные группы')}>
        <MultiSelect
          options={tags}
          onSelect={(e) => handleUpdateQr({ tags: e })}
          value={selectedTags}
          data-testid="qr-groups"
        />
      </Container>
      {qr?.services?.includes('menu') && (
        <Container label={t('Выберите меню')}>
          <MultiSelect
            options={menuOptions.options}
            onSelect={(e) => handleUpdateQr({ menu_ids: e.map((item) => item.id) })}
            value={menuOptions.selected}
            data-testid="qr-menus"
          />
        </Container>
      )}
    </Card>
  );
};
